<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col md="12">
          <b-card>
            <div slot="header">
              <strong>Notification Status</strong>
            </div>
            <b-row class="align-items-center mb-3">
              <b-col md="4" class="d-flex align-items-center">
                <b-form-group label="Filter :" label-cols="2" class="mb-0 w-100">
                  <b-input-group>
                    <b-form-input
                      v-model="filter"
                      placeholder="B2D Id"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button 
                        @click="getNotificationStatusList"
                        size="md"
                        variant="primary"
                      >Search</b-button>
                      <b-button 
                        :disabled="!filter" 
                        @click="clearSearch()" 
                        size="md"
                        variant="danger"
                        class="ml-2"
                      >Clear</b-button> 
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            
              <!-- Total Records -->
              <b-col md="8" class="text-right">
                <p class="mb-0">
                  <strong>Total Records: <span style="color:red;">{{ totalCount }}</span></strong>
                </p>
              </b-col>
            </b-row>
            <b-col md="12">
              <!-- {{ items }} -->
               <b-table show-empty responsive  :items="items" :fields="fields" :per-page="perPageplan"
                :current-page="currentPageplan" id="my-tableplan"> 

                <template slot="loadid" slot-scope="row" >
                   <button class="btn btn-sm btn-primary mr-4" title="View QR Code." @click="openLoadIds(getSmsResult(row.item.sms_response))">
                     Show Load Id's
                    </button>
                </template>
                <template slot="transactionid" slot-scope="row" >
                  <span>{{ getSmsResult(row.item.sms_response) }}</span>
                </template>
                <template slot="status" slot-scope="row" >
                  <div v-if="row.item.whatsapp_synced_status==true || row.item.email_synced_status==true ||row.item.sms_synced_status==true ">
                    <b-badge :variant="'success'" class="text-capitalize">
                    {{ 'Success'}}
                  </b-badge>
                 </div>
                 <div v-else>
                  <b-badge :variant="'warning'" class="text-capitalize">
                    {{ 'Pending'}}
                  </b-badge>
                 </div>
                </template>


              </b-table>
                
            </b-col>                 
            <b-row>
              <b-col>
                <b-pagination
                  v-model="Pageplan"
                  :total-rows="rowsplan"
                  :per-page="perPageplan"
                  aria-controls="my-tableplan"
                  @input="onPageChange"
                ></b-pagination>
              </b-col>
            </b-row>
            <b-modal id="load-id-modal" title="Load IDs" v-model="isLoadIdModalOpen" @hide="resetLoadIds">
              <div v-if="getCleanLoadIds().length">
                <p v-for="(id, index) in getCleanLoadIds()" :key="index">{{ id }}</p>
              </div>
              <p v-else>No Load IDs available.</p>
            </b-modal>            
          </b-card>
        </b-col>
      </b-row>
    </div>
</template>
<script>
import CONSTANTS from '@/utils/constants';
  export default {
    name: 'notificationStatus',
    data() {
      return {
        fields: [
              { key: 'loadid', label: 'Load ID'},
              { key: 'transactionid', label: 'Transaction Id'},
              { key: 'distributorname', label: 'Distributor Name'},
              { key: 'b2bid', label: 'B2D Id'},
              { key: 'createdat', label: 'OFD Timestamp'},
              { key: 'role', label: 'Role'},
              { key: 'status', label: 'Status'}              
        ],
        currentPageplan : 1,
        perPageplan: 10,
        items:[],
        showModal: false,
        isLoadIdModalOpen: false,
        modalLoadIds: [],
        filter:'',
        totalCount:0,
        Pageplan:1,       
      }
    },
    created (){
      this.getNotificationStatusList();
    },
    computed: {
      rowsplan() {
        return Number(this.totalCount) || 0;
      }
    },
    methods: {
      getNotificationStatusList:function(b2did){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)        
        const obj ={
          b2did:this.filter,
          page_no:this.Pageplan,
        }      
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllB2dUsers`,obj)
            .then(result => {                
            if (result.body.returnmsg === 'Success' && result.body.returnvalue != 'No Record Found' && result.body.returnvalue.length > 0) {
                console.log("result.body.returnvalue----->>>>>>>", result.body.returnvalue);
                this.items = [...result.body.returnvalue];               
                this.totalCount=result.body.returnvalue[0].total_count;
                console.log(" this.items----->>>>>>>", this.items);  
                console.log("  this.totalCount----->>>>>>>",  this.totalCount);                                                    
            } else {              
                this.items=[];
                this.totalCount = 0;
            }
        }).catch(ex => {
            console.log("error-----", ex);
        });
      },
      openLoadIds(transactionid) {
        console.log("TRANSACTION ID------------>>>>>>",transactionid);
        // return false;
        this.isLoadIdModalOpen = true;
        const obj = {
          transactionid: transactionid,
          type: "sms"    // sms/email
        }
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllAWBAginstTrainsaction`,obj).then(result => {                
            if (result.body.returnmsg === 'Success') {
                this.modalLoadIds=result.body.returnvalue;
                console.log(" this.modalLoadIds----->>>>>>>", this.modalLoadIds);                                                      
            } else {              
                this.modalLoadIds=[];
            }
        }).catch(ex => {
            console.log("error-----", ex);
        });
      },
      resetLoadIds() {
        this.modalLoadIds = [];
      },
      getCleanLoadIds() {
        if (!this.modalLoadIds.length) return [];
        try {
          const raw = this.modalLoadIds[0].loadids;
          return raw
            .replace(/[{}"]/g, '') // Remove special characters
            .split(',')            // Split into individual IDs
            .map(id => id.trim()); // Trim whitespace if any
        } catch (e) {
          return [];
        }
      },
      getSmsResult(smsResponse) {
        if (!smsResponse) return '-';
        try {
          // Parse if it's a JSON string with double quotes escaped (as in your case)
          const unescaped = smsResponse.replace(/^"|"$/g, '').replace(/\\"/g, '"');
          const parsed = JSON.parse(unescaped);
          return parsed.SendSMSResult || '-';
        } catch (err) {
          console.error('Failed to parse sms_response:', smsResponse, err);
          return '-';
        }
      },
      clearSearch(){
        this.filter='';
        this.getNotificationStatusList();
      },
      onPageChange(page) {
        this.Pageplan = page;
        this.getNotificationStatusList(); 
      },
    }
}

</script>